<div class="view-container">

  <div class="d-flex flex-row align-items-center gap-4 mb-2">
    <ds-metadata-link-view-avatar-popover
      *ngIf="item.thumbnail | async"
      [thumbnail]="item.thumbnail | async"
      [entityType]="item.entityType"
    ></ds-metadata-link-view-avatar-popover>
    <span class="font-weight-bold h4"> {{item.firstMetadataValue('dc.title')}} </span>
  </div>

  <ng-container *ngFor="let metadata of entityMetdataFields">
    <div class="row" *ngIf="item.hasMetadata(metadata)">
      <div class="col-4">
        <span class="font-weight-bold">{{ "metadata-link-view.popover.label." +  (isOtherEntityType ? "other" : item.entityType) + "." +  metadata | translate }}</span>
      </div>
      <div class="col-8">
        <span class="ellipsis-y-3" *ngIf="longTextMetadataList.includes(metadata)">
          {{ item.firstMetadataValue(metadata) }}
        </span>
        <a [href]="item.firstMetadataValue(metadata)" target="_blank" *ngIf="isLink(item.firstMetadataValue(metadata)) && !getSourceSubTypeIdentifier(metadata)">
          {{ item.firstMetadataValue(metadata) }}
        </a>

        <div *ngIf="getSourceSubTypeIdentifier(metadata)" class="d-flex align-items-center">
          <ng-container *ngVar="item.firstMetadataValue(metadata) as rorValue">
            <a *ngIf="isLink(rorValue)" [href]="item.firstMetadataValue(metadata)" target="_blank" >
              {{ item.firstMetadataValue(metadata) }}
            </a>
            <a *ngIf="!isLink(rorValue)" [href]="getSourceSubTypeIdentifier(metadata)?.link + '/' + item.firstMetadataValue(metadata)" target="_blank" >
              {{ item.firstMetadataValue(metadata) }}
            </a>
          </ng-container>
          <img
            placement="top"
            [ngbTooltip]="getSourceSubTypeIdentifier(metadata)?.link"
            class="source-icon"
            alt="source-logo"
            [src]="getSourceSubTypeIdentifier(metadata)?.icon"
            data-test="sourceIcon"
          />
        </div>

        <div class="d-flex" *ngIf="!isLink(item.firstMetadataValue(metadata)) && !longTextMetadataList.includes(metadata)">
          <ds-metadata-link-view-orcid [itemValue]="item" *ngIf="metadata === 'person.identifier.orcid'; else textType"></ds-metadata-link-view-orcid>
          <ng-template #textType>
            <span class="ellipsis-y-1">{{ item.firstMetadataValue(metadata) }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="d-flex">
    <a
      class="font-weight-bold"
      [routerLink]="[getItemPageRoute()]"
      data-test="more-info-link"
    >
      {{ "metadata-link-view.popover.label.more-info" | translate }}
    </a>
  </div>
</div>
